import React, { Suspense, useState, useEffect } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { ThemeProvider } from '@material-ui/core/styles';
import Amplify, { Auth } from 'aws-amplify';
import { LicenseInfo } from '@mui/x-data-grid-pro';
import { GlobalStyles, theme } from './styles';
import Loading from './components/Loading';
import { routes } from './config/routes';
import GlobalSpinner from './components/GlobalSpinner';
import { amplifyConfig } from './config/env';
import ErrorBoundary from './components/ErrorBoundary';
import { setUserAuthenticated, setUserLoading } from './redux/actions';

LicenseInfo.setLicenseKey(process.env.REACT_APP_X_LICENSE);

const VaultingScreen = React.lazy(() => import('./pages/VaultingScreen'));
const ManagementScreen = React.lazy(() => import('./pages/ManagementScreen'));

Amplify.configure(amplifyConfig);

function App() {
  const dispatch = useDispatch();

  const [notification, setNotification] = useState({
    state: false,
    message: '',
    type: 'error',
  });

  const handleCloseError = (e) => {
    e.preventDefault();
    setNotification({ state: false, message: '' });
  };

  const checkUserSession = async () => {
    await Auth.currentSession()
      .then(() => {
        dispatch(setUserAuthenticated(true));
      })
      .catch((err) => {
        setNotification({
          state: true,
          message: err
            ? err?.message || err.toString()
            : 'Unknown session Error',
        });
        dispatch(setUserAuthenticated(false));
      });
    dispatch(setUserLoading(false));
  };

  useEffect(() => {
    const interval = setInterval(() => {
      checkUserSession();
    }, 1000 * 60 * 5);
    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <div className="App">
      <GlobalStyles />
      <ThemeProvider theme={theme}>
        <GlobalSpinner />
        <Router>
          <Suspense fallback={<Loading />}>
            <Switch>
              <Route exact path={routes.VAULT} component={VaultingScreen} />
              <Route exact path={routes.MGMT}>
                <ErrorBoundary>
                  <ManagementScreen
                    handleCloseError={handleCloseError}
                    notification={notification}
                    setNotification={setNotification}
                    checkUserSession={checkUserSession}
                  />
                </ErrorBoundary>
              </Route>
            </Switch>
          </Suspense>
        </Router>
      </ThemeProvider>
    </div>
  );
}

export default App;
